// assets/ce-size-guide.js — Tabela de medidas + "Descubra seu tamanho"
// Funciona com qualquer tabela: a 1ª coluna é o tamanho/numeração e as demais são medidas com nomes livres.
// O "Descubra seu tamanho" se adapta às colunas da tabela:
//   - tórax/peito/busto, cintura ou quadril -> provador pelo corpo (altura, peso, idade + manequim)
//   - comprimento do pé ou palmilha          -> pede o comprimento do pé
//   - nenhuma delas                          -> o link fica escondido e só a tabela aparece
(function () {
  const root = document.querySelector('[data-ce-sg]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  let data = { cols: [], sizes: [] };
  try { data = JSON.parse(root.querySelector('[data-ce-sg-data]').textContent); } catch (e) {}

  const num = (v) => { const t = String(v == null ? '' : v).trim(); return /^-?\d+([.,]\d+)?$/.test(t) ? parseFloat(t.replace(',', '.')) : null; };
  const norm = (s) => String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fmt = (n) => Number(n).toLocaleString('pt-BR', { maximumFractionDigits: 1 });
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

  const unit = data.unit || 'cm';
  const sizeLabel = data.sizeLabel || 'Tamanho';
  // Colunas vindas das caixinhas do Guia de Medidas: {key, name, values[]} — só entram as que têm valores.
  const rawCols = (Array.isArray(data.cols) ? data.cols : [])
    .map((c) => ({ key: c.key, name: String(c.name || '').trim(), values: Array.isArray(c.values) ? c.values : [] }))
    .filter((c) => c.name && c.values.some((v) => v != null && String(v).trim() !== ''));
  const cols = rawCols.map((c) => c.name);
  const sizes = (Array.isArray(data.sizes) ? data.sizes : []).map((t, i) => ({
    size: String(t == null ? '' : t).trim(),
    raw: rawCols.map((c) => String(c.values[i] == null ? '' : c.values[i]).trim()),
    values: rawCols.map((c) => num(c.values[i]))
  })).filter((s) => s.size);

  // Qual linha da ilustração corresponde a cada medida
  const LINES = ['ombro', 'comprimento', 'torax', 'manga', 'largura_manga'];
  const lineFor = (key, name) => {
    if (LINES.includes(key)) return key;
    const n = norm(name);
    if (/palmilha|\bpes?\b/.test(n)) return 'pe';
    if (/torax|peito/.test(n)) return 'torax';
    if (/ombro/.test(n)) return 'ombro';
    if (/largura/.test(n) && /manga/.test(n)) return 'largura_manga';
    if (/manga/.test(n)) return 'manga';
    if (/comprimento/.test(n)) return 'comprimento';
    return '';
  };
  const colLines = rawCols.map((c) => lineFor(c.key, c.name));
  const HOW = {
    ombro: 'De uma costura do ombro até a outra, em linha reta.',
    comprimento: 'Do ponto mais alto do ombro, junto à gola, até a barra.',
    torax: 'De uma axila à outra, com a peça estendida. É a largura da peça, não a volta do corpo.',
    manga: 'Da costura do ombro até a barra da manga.',
    largura_manga: 'Na barra da manga, de uma ponta à outra.',
    pe: 'Do calcanhar até a ponta do dedo mais longo.'
  };

  // ---------- Janelas (modais) ----------
  const modals = {};
  root.querySelectorAll('[data-ce-sg-modal]').forEach((m) => { modals[m.dataset.ceSgModal] = m; document.body.appendChild(m); });
  let active = null;
  let lastTrigger = null;

  const focusables = (el) => [...el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')]
    .filter((x) => x.offsetParent !== null);

  function open(name, trigger) {
    const m = modals[name];
    if (!m) return;
    if (active && active !== m) active.hidden = true;
    else lastTrigger = trigger || document.activeElement;
    active = m;
    m.hidden = false;
    document.documentElement.classList.add('ce-sg-lock');
    if (name === 'tabela') initTabela();
    if (name === 'provador') initProvador();
    requestAnimationFrame(() => {
      const f = [...m.querySelectorAll('[data-ce-sg-autofocus]')].find((x) => x.offsetParent !== null) || m.querySelector('.ce-sg-x');
      if (f) f.focus({ preventScroll: true });
    });
  }
  function close() {
    if (!active) return;
    active.hidden = true;
    active = null;
    document.documentElement.classList.remove('ce-sg-lock');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-ce-sg-open]');
    if (o) { e.preventDefault(); open(o.dataset.ceSgOpen, o); return; }
    const c = e.target.closest('[data-ce-sg-close]');
    if (c && active && active.contains(c)) close();
  });
  document.addEventListener('keydown', (e) => {
    if (!active) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables(active);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  // ---------- Seletor de tamanho da página ----------
  const option = data.option || 'Tamanho';
  function currentSize() {
    const r = [...document.querySelectorAll('variant-radios input[type="radio"]:checked')].find((i) => i.name === option);
    if (r) return r.value;
    const s = [...document.querySelectorAll('variant-selects select')].find((x) => (x.name || '').includes(option));
    return s ? s.value : null;
  }
  function selectSize(size) {
    const r = [...document.querySelectorAll('variant-radios input[type="radio"]')].find((i) => i.name === option && i.value === size);
    if (r) {
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const s = [...document.querySelectorAll('variant-selects select')].find((x) => [...x.options].some((o) => o.value === size));
    if (s) { s.value = size; s.dispatchEvent(new Event('change', { bubbles: true })); return true; }
    return false;
  }

  // ---------- Tabela de medidas ----------
  const tab = modals.tabela;
  const guide = tab && tab.querySelector('[data-ce-sg-guide]');
  const cap = tab && tab.querySelector('[data-ce-sg-guide-cap]');
  const photo = tab && tab.querySelector('[data-ce-sg-media="foto"]');
  const hasImg = !!(tab && tab.querySelector('.ce-sg-tape__img'));
  let tabIdx = 0;
  let tabBuilt = false;
  let fita = false;
  let activeRow = null;
  let lastPointer = 'mouse';

  function setLines(line) {
    if (guide) guide.querySelectorAll('.ce-sg-ln').forEach((g) => g.classList.toggle('is-off', line !== 'all' && g.dataset.line !== line));
  }
  // Mostra no lugar da foto a ilustração com a linha da medida destacada
  function showGuide(row) {
    const line = row && row.dataset.line;
    if (!guide || !line || !guide.querySelector(`.ce-sg-ln[data-line="${line}"]`)) { resetGuide(); return; }
    tab.querySelectorAll('.ce-sg-measures__row').forEach((r) => r.classList.toggle('is-active', r === row));
    activeRow = row;
    setLines(line);
    if (photo) photo.hidden = true;
    guide.hidden = false;
    tab.classList.add('is-guide');
    cap.innerHTML = `<strong>${esc(row.dataset.name)} · ${esc(row.dataset.val)}</strong>${esc(HOW[line] || '')}`;
  }
  // Volta para a foto (ou para todas as linhas, se a Fita métrica estiver aberta)
  function resetGuide() {
    activeRow = null;
    if (!tab) return;
    tab.querySelectorAll('.ce-sg-measures__row.is-active').forEach((r) => r.classList.remove('is-active'));
    tab.classList.remove('is-guide');
    if (!guide) return;
    if (fita) {
      guide.hidden = hasImg;
      setLines('all');
      cap.textContent = '';
    } else {
      guide.hidden = true;
      if (photo) photo.hidden = false;
    }
  }

  function initTabela() {
    if (!tab || !sizes.length) return;
    if (!tabBuilt) {
      const track = tab.querySelector('[data-ce-sg-track]');
      track.innerHTML = sizes.map((s, i) => `<button type="button" class="ce-sg-size" role="radio" aria-checked="false" tabindex="-1" data-i="${i}">${esc(s.size)}</button>`).join('');
      track.addEventListener('click', (e) => { const b = e.target.closest('.ce-sg-size'); if (b) renderTabela(+b.dataset.i); });
      track.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        renderTabela(tabIdx + d);
        track.querySelector(`[data-i="${tabIdx}"]`).focus();
      });
      tab.querySelector('[data-ce-sg-prev]').addEventListener('click', () => renderTabela(tabIdx - 1));
      tab.querySelector('[data-ce-sg-next]').addEventListener('click', () => renderTabela(tabIdx + 1));

      const dl = tab.querySelector('[data-ce-sg-measures]');
      dl.addEventListener('pointerdown', (e) => { lastPointer = e.pointerType; });
      dl.addEventListener('pointerover', (e) => {
        if (e.pointerType !== 'mouse') return;
        const r = e.target.closest('.ce-sg-measures__row');
        if (r && r !== activeRow) showGuide(r);
      });
      dl.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') resetGuide(); });
      dl.addEventListener('click', (e) => {
        if (lastPointer === 'mouse') return; // no computador o hover já faz o trabalho
        const r = e.target.closest('.ce-sg-measures__row');
        if (!r) return;
        if (r === activeRow) resetGuide(); else showGuide(r);
      });
      dl.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const r = e.target.closest('.ce-sg-measures__row');
        if (!r) return;
        e.preventDefault();
        if (r === activeRow) resetGuide(); else showGuide(r);
      });
      dl.addEventListener('focusout', (e) => { if (!dl.contains(e.relatedTarget)) resetGuide(); });

      // Fita métrica: abre/recolhe como uma sanfona (cabeçalho com seta + botão ✕ dentro da área aberta)
      const tape = tab.querySelector('[data-ce-sg-tape]');
      const tapeState = tab.querySelector('[data-ce-sg-tape-state]');
      const setFita = (on) => {
        fita = on;
        tape.setAttribute('aria-expanded', on);
        if (tapeState) tapeState.textContent = on ? 'Recolher' : 'Ver como medir';
        tab.querySelector('[data-ce-sg-media="fita"]').hidden = !on;
        if (photo) photo.hidden = on;
        tab.classList.toggle('is-fita', on);
        resetGuide();
        if (on && window.matchMedia('(max-width: 749px)').matches) {
          const area = tab.querySelector('#ce-sg-fita-area');
          if (area) requestAnimationFrame(() => area.scrollIntoView({ block: 'nearest', behavior: 'smooth' }));
        }
      };
      if (tape) {
        tape.addEventListener('click', () => setFita(!fita));
        const x = tab.querySelector('[data-ce-sg-fita-close]');
        if (x) x.addEventListener('click', () => { setFita(false); tape.focus({ preventScroll: true }); });
      }
      tabBuilt = true;
    }
    const i = sizes.findIndex((s) => s.size === currentSize());
    renderTabela(i >= 0 ? i : tabIdx);
  }
  function renderTabela(i) {
    tabIdx = clamp(i, 0, sizes.length - 1);
    const track = tab.querySelector('[data-ce-sg-track]');
    track.querySelectorAll('.ce-sg-size').forEach((b, k) => {
      const on = k === tabIdx;
      b.setAttribute('aria-checked', on);
      b.tabIndex = on ? 0 : -1;
      if (on) track.scrollTo({ left: b.offsetLeft - (track.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
    });
    tab.querySelector('[data-ce-sg-prev]').disabled = tabIdx === 0;
    tab.querySelector('[data-ce-sg-next]').disabled = tabIdx === sizes.length - 1;
    const s = sizes[tabIdx];
    const keep = activeRow && activeRow.dataset.line;
    tab.querySelector('[data-ce-sg-measures]').innerHTML = cols.map((c, k) => {
      if (!s.raw[k]) return '';
      const v = s.values[k] != null ? `${fmt(s.values[k])} ${unit}` : s.raw[k];
      const line = guide && colLines[k] && guide.querySelector(`.ce-sg-ln[data-line="${colLines[k]}"]`) ? colLines[k] : '';
      return `<div class="ce-sg-measures__row${line ? ' has-guide' : ''}" data-line="${line}" data-name="${esc(c)}" data-val="${esc(v)}"${line ? ' tabindex="0"' : ''}><dt>${esc(c)}</dt><dd>${esc(v)}</dd></div>`;
    }).join('');
    if (keep) {
      const r = tab.querySelector(`.ce-sg-measures__row[data-line="${keep}"]`);
      if (r) showGuide(r); else resetGuide();
    }
  }

  // ---------- Descubra seu tamanho ----------
  // Colunas que o provador pelo corpo entende. Medida "flat" (peça na mesa) abaixo do limite é dobrada (vira circunferência).
  const BODY = [
    { id: 'torax', re: /torax|peito|busto/, flat: 75, min: 4, max: 14, ideal: 8, nome: 'tórax' },
    { id: 'cintura', re: /cintura/, flat: 60, min: 0, max: 6, ideal: 2, nome: 'cintura' },
    { id: 'quadril', re: /quadril/, flat: 70, min: 2, max: 10, ideal: 5, nome: 'quadril' }
  ];
  // Calçado: palmilha (folga ideal de ~1 cm) ou comprimento do pé (compara direto).
  const FOOT = [
    { id: 'pe', re: /palmilha/, min: 0.5, max: 1.8, ideal: 1, nome: 'comprimento' },
    { id: 'pe', re: /\bpes?\b|\bfoot\b/, min: -0.3, max: 0.8, ideal: 0.2, nome: 'comprimento' }
  ];
  const findCol = (k) => Object.assign({}, k, { col: cols.findIndex((c) => k.re.test(norm(c))) });
  const bodyCols = BODY.map(findCol).filter((k) => k.col >= 0);
  const footCol = FOOT.map(findCol).find((k) => k.col >= 0);
  const mode = !sizes.length ? null : bodyCols.length ? 'corpo' : footCol ? 'pe' : null;
  const keys = mode === 'corpo' ? bodyCols : mode === 'pe' ? [footCol] : [];
  document.querySelectorAll('[data-ce-sg-open="provador"]').forEach((b) => { b.hidden = !mode; });

  const prov = modals.provador;
  const STORE = 'ce-provador';
  const state = { step: 1, altura: null, peso: null, idade: null, pe: null, adj: { torax: 0, cintura: 0, quadril: 0 }, results: [], best: -1, view: -1 };
  let provBuilt = false;
  const FIT = mode === 'pe' ? { justo: 'Apertado', ideal: 'Ideal', folgado: 'Folgado' } : { justo: 'Justo', ideal: 'Ideal', folgado: 'Folgado' };
  const editStep = () => (mode === 'pe' ? 'pe' : 2);

  function load() {
    try {
      const s = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (s) Object.assign(state, { altura: s.altura, peso: s.peso, idade: s.idade, pe: s.pe, adj: Object.assign(state.adj, s.adj || {}) });
    } catch (e) {}
  }
  function save() {
    try { localStorage.setItem(STORE, JSON.stringify({ altura: state.altura, peso: state.peso, idade: state.idade, pe: state.pe, adj: state.adj })); } catch (e) {}
  }

  // Estimativa das medidas do corpo (masculino) por altura, peso e idade. Cada passo do ajuste soma 3 cm.
  function bodyMeasures() {
    const a = state.altura, p = state.peso, age = clamp(state.idade || 30, 15, 80);
    return {
      torax: 88 + 0.6 * (p - 60) - 0.15 * (a - 170) + 0.05 * (age - 25) + state.adj.torax * 3,
      cintura: 76 + 0.8 * (p - 60) - 0.25 * (a - 170) + 0.15 * (age - 25) + state.adj.cintura * 3,
      quadril: 92 + 0.5 * (p - 60) - 0.05 * (a - 170) + state.adj.quadril * 3
    };
  }
  function evaluate(b) {
    return sizes.map((s) => {
      let score = 0;
      const fits = {};
      keys.forEach((k) => {
        let g = s.values[k.col];
        if (g == null) return;
        if (k.flat && g < k.flat) g *= 2;
        const folga = g - b[k.id];
        fits[k.id] = folga < k.min ? 'justo' : folga > k.max ? 'folgado' : 'ideal';
        // ficar apertado pesa 3x mais do que sobrar
        score += (folga < k.min ? 3 : 1) * Math.abs((folga - k.ideal) / (k.max - k.min));
      });
      return { size: s.size, score, fits, main: fits[keys[0].id] || 'ideal' };
    });
  }

  // Manequim em SVG (sem cor de pele), formato ajustado por tórax, cintura e quadril.
  function smooth(pts) {
    const n = pts.length;
    let d = `M${pts[0][0].toFixed(1)} ${pts[0][1].toFixed(1)}`;
    for (let i = 0; i < n; i++) {
      const p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
      const c1 = [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6];
      const c2 = [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6];
      d += `C${c1[0].toFixed(1)} ${c1[1].toFixed(1)} ${c2[0].toFixed(1)} ${c2[1].toFixed(1)} ${p2[0].toFixed(1)} ${p2[1].toFixed(1)}`;
    }
    return d + 'Z';
  }
  const mirror = (pts) => pts.map(([x, y]) => [200 - x, y]).reverse();
  let uid = 0;
  function mannequin(b, fit) {
    const gid = `ce-sg-g${++uid}`, hid = `ce-sg-h${uid}`; // ids únicos: o desenho aparece em mais de um passo
    const c = clamp(25 + (b.torax - 88) * 0.36, 18, 44);
    const w = clamp(21 + (b.cintura - 76) * 0.36, 14, 44);
    const h = clamp(25 + (b.quadril - 92) * 0.32, 18, 44);
    const sh = c + 15;
    const R = [[108, 46], [109, 60], [100 + sh - 10, 70], [100 + sh - 1, 78], [100 + sh + 3, 92], [100 + c + 2, 112], [100 + c, 125],
      [100 + (c + w) / 2 + 1, 160], [100 + w, 190], [100 + (w + h) / 2, 212], [100 + h, 232], [100 + h - 2, 250], [104, 258]];
    const torso = R.map(([x, y]) => [200 - x, y]).concat([[100, 262]], R.slice().reverse());
    const armR = [[100 + sh - 4, 80], [100 + sh + 4, 92], [100 + sh + 6, 128], [100 + sh + 7, 165], [100 + sh + 8, 200], [100 + sh + 7, 228],
      [100 + sh + 8, 247], [100 + sh + 3, 259], [100 + sh - 3, 251], [100 + sh - 3, 230], [100 + sh - 4, 200], [100 + sh - 5, 166], [100 + c + 4, 132], [100 + c + 2, 112]];
    const legR = [[100 + h - 1, 236], [100 + h, 270], [100 + h * 0.88, 310], [100 + h * 0.72, 342], [100 + h * 0.74, 366], [100 + h * 0.62, 402],
      [100 + h * 0.5, 428], [100 + h * 0.56, 438], [104, 438], [105, 428], [105, 402], [104, 368], [104, 342], [103, 300], [101, 262]];
    const part = (pts) => `<path d="${smooth(pts)}" fill="url(#${gid})" stroke="#c4c4c4" stroke-width=".6" stroke-linejoin="round"/>`;
    let band = '';
    if (fit) {
      const col = { justo: '#B54A3A', ideal: '#3E7C57', folgado: '#D9A441' }[fit];
      for (let k = -2; k <= 2; k++) {
        const y = 124 + k * 5;
        band += `<path d="M${(100 - c - 1).toFixed(1)} ${y} Q100 ${y + 11} ${(100 + c + 1).toFixed(1)} ${y}" fill="none" stroke="${col}" stroke-linecap="round" stroke-width="${k ? 2 : 3.5}" opacity="${k ? 0.22 : 1}"/>`;
      }
    }
    return `<svg viewBox="0 0 200 448" role="img" aria-label="Manequim com as medidas informadas" focusable="false">
      <defs><linearGradient id="${gid}" x1="0" x2="1"><stop offset="0" stop-color="#cfcfcf"/><stop offset=".3" stop-color="#efefef"/><stop offset=".5" stop-color="#fafafa"/><stop offset=".72" stop-color="#ececec"/><stop offset="1" stop-color="#c9c9c9"/></linearGradient>
      <radialGradient id="${hid}" cx=".45" cy=".4" r=".7"><stop offset="0" stop-color="#fbfbfb"/><stop offset="1" stop-color="#cdcdcd"/></radialGradient></defs>
      <ellipse cx="100" cy="440" rx="${(h * 1.3).toFixed(1)}" ry="4" fill="#000" opacity=".06"/>
      ${part(armR)}${part(mirror(armR))}${part(legR)}${part(mirror(legR))}${part(torso)}
      <ellipse cx="100" cy="28" rx="15.5" ry="20" fill="url(#${hid})" stroke="#c4c4c4" stroke-width=".6"/>
      ${band}</svg>`;
  }

  function initProvador() {
    if (!prov || !mode) return;
    if (!provBuilt) { buildProvador(); provBuilt = true; }
    load();
    ['altura', 'peso', 'idade', 'pe'].forEach((n) => {
      const i = prov.querySelector(`[name="${n}"]`);
      if (i && state[n]) i.value = state[n];
    });
    prov.querySelectorAll('[data-adj]').forEach((r) => { r.value = state.adj[r.dataset.adj] || 0; });
    goStep(mode === 'pe' ? 'pe' : 1);
  }

  function readStep1() {
    const v = (n) => num(prov.querySelector(`[name="${n}"]`).value);
    const a = v('altura'), p = v('peso'), i = v('idade');
    const ok = a >= 120 && a <= 230 && p >= 35 && p <= 250 && i >= 12 && i <= 100;
    if (ok) Object.assign(state, { altura: a, peso: p, idade: i });
    return ok;
  }
  function readPe() {
    let v = num(prov.querySelector('[name="pe"]').value);
    if (v > 100) v = v / 10; // digitou em milímetros
    const ok = v >= 12 && v <= 35;
    if (ok) state.pe = v;
    return ok;
  }

  function buildProvador() {
    prov.classList.toggle('is-pe', mode === 'pe');
    const tabBtn = prov.querySelector('[data-ce-sg-bodytab]');
    if (tabBtn) tabBtn.textContent = mode === 'pe' ? 'Medida do pé' : 'Medidas corporais';

    const next1 = prov.querySelector('[data-ce-sg-next1]');
    prov.querySelectorAll('[data-ce-sg-step="1"] input').forEach((i) => i.addEventListener('input', () => { next1.disabled = !readStep1(); }));
    prov.querySelector('[data-ce-sg-form1]').addEventListener('submit', (e) => {
      e.preventDefault();
      const ok = readStep1();
      prov.querySelector('[data-ce-sg-err1]').hidden = ok;
      if (!ok) return;
      save();
      goStep(2);
    });

    const nextPe = prov.querySelector('[data-ce-sg-nextpe]');
    prov.querySelector('[name="pe"]').addEventListener('input', () => { nextPe.disabled = !readPe(); });
    prov.querySelector('[data-ce-sg-formpe]').addEventListener('submit', (e) => {
      e.preventDefault();
      const ok = readPe();
      prov.querySelector('[data-ce-sg-errpe]').hidden = ok;
      if (!ok) return;
      save();
      goStep(3);
    });

    prov.querySelectorAll('[data-adj]').forEach((r) => r.addEventListener('input', () => { state.adj[r.dataset.adj] = +r.value; drawBody(); }));
    prov.querySelectorAll('[data-ce-sg-adj-btn]').forEach((b) => b.addEventListener('click', () => {
      const r = prov.querySelector(`[data-adj="${b.dataset.key}"]`);
      r.value = clamp(+r.value + +b.dataset.ceSgAdjBtn, -2, 2);
      state.adj[b.dataset.key] = +r.value;
      drawBody();
    }));
    prov.querySelector('[data-ce-sg-back]').addEventListener('click', () => goStep(1));
    prov.querySelector('[data-ce-sg-next2]').addEventListener('click', () => { save(); goStep(3); });
    prov.querySelectorAll('[data-ce-sg-edit]').forEach((b) => b.addEventListener('click', () => goStep(editStep())));
    prov.querySelector('[data-ce-sg-chips]').addEventListener('click', (e) => {
      const b = e.target.closest('[data-i]');
      if (b) { state.view = +b.dataset.i; drawResult(); }
    });
    prov.querySelector('[data-ce-sg-choose]').addEventListener('click', () => {
      const r = state.results[state.view];
      if (r && selectSize(r.size)) close();
    });
    const info = prov.querySelector('[data-ce-sg-info]');
    if (info) info.addEventListener('click', () => {
      const t = prov.querySelector('[data-ce-sg-tip]');
      const on = t.hidden;
      t.hidden = !on;
      info.setAttribute('aria-expanded', on);
    });
  }

  function goStep(n) {
    state.step = n;
    prov.dataset.step = n;
    prov.querySelectorAll('[data-ce-sg-step]').forEach((s) => { s.hidden = s.dataset.ceSgStep !== String(n); });
    prov.querySelector('[data-ce-sg-media="foto"]').hidden = n === 2;
    prov.querySelector('[data-ce-sg-media="corpo"]').hidden = n !== 2;
    prov.querySelectorAll('.ce-sg-dots span').forEach((d) => { d.classList.toggle('is-on', +d.dataset.d === (n === 2 ? 2 : 1)); });
    if (n === 1) prov.querySelector('[data-ce-sg-next1]').disabled = !readStep1();
    if (n === 'pe') prov.querySelector('[data-ce-sg-nextpe]').disabled = !readPe();
    if (n === 2) drawBody();
    if (n === 3) compute();
    const sel = `[data-ce-sg-step="${n}"]`;
    const first = prov.querySelector(`${sel} [data-ce-sg-autofocus], ${sel} input, ${sel} button`);
    if (first && active === prov) first.focus({ preventScroll: true });
  }

  function drawBody() {
    prov.querySelector('[data-ce-sg-body]').innerHTML = mannequin(bodyMeasures(), null);
  }

  function compute() {
    state.results = evaluate(mode === 'pe' ? { pe: state.pe } : bodyMeasures());
    let best = 0;
    state.results.forEach((r, i) => { if (r.score <= state.results[best].score) best = i; });
    state.best = best;
    state.view = best;
    drawResult();
    const b = state.results[best];
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ce_provador_resultado', modo: mode, tamanho: b.size, caimento: b.main, produto: data.product });
    } catch (e) {}
    const wa = prov.querySelector('[data-ce-sg-wa]');
    if (wa && data.wa) {
      const medidas = mode === 'pe' ? `Meu pé mede ${fmt(state.pe)} cm.` : `Tenho ${fmt(state.altura)} cm, ${fmt(state.peso)} kg e ${fmt(state.idade)} anos.`;
      const msg = `Olá! Estou em dúvida sobre ${sizeLabel.toLowerCase()} da ${data.product}. ${medidas} O site indicou ${b.size}.`;
      wa.href = `https://wa.me/${data.wa}?text=${encodeURIComponent(msg)}`;
    }
  }

  function drawResult() {
    const rs = state.results;
    const best = rs[state.best];
    const view = rs[state.view];
    const k0 = keys[0];
    prov.querySelector('[data-ce-sg-best]').textContent = best.size;
    let txt;
    if (best.main === 'folgado' && state.best === 0) txt = 'Mesmo a menor opção desta peça fica com sobra.';
    else if (best.main === 'justo' && state.best === rs.length - 1) txt = 'Mesmo a maior opção desta peça fica justa. Fale com um consultor antes de comprar.';
    else if (mode === 'pe') txt = `Para o seu pé de ${fmt(state.pe)} cm, indicamos ${best.size}.`;
    else txt = `Com ${fmt(state.altura)} cm e ${fmt(state.peso)} kg, indicamos ${best.size} para esta peça.`;
    prov.querySelector('[data-ce-sg-best-txt]').textContent = txt;
    prov.querySelector('[data-ce-sg-chips]').innerHTML = rs.map((r, i) => {
      const ok = i === state.best || r.main === 'ideal';
      return `<button type="button" class="ce-sg-chip${i === state.view ? ' is-on' : ''}" data-i="${i}" aria-pressed="${i === state.view}" aria-label="${esc(sizeLabel)} ${esc(r.size)}: ${FIT[r.main]}">
        ${esc(r.size)}<span class="ce-sg-chip__mark ${ok ? 'is-ok' : 'is-no'}" aria-hidden="true">${ok ? '✓' : '✕'}</span></button>`;
    }).join('');
    const viewfit = prov.querySelector('[data-ce-sg-viewfit]');
    if (mode === 'corpo') {
      prov.querySelector('[data-ce-sg-fitbody]').innerHTML = mannequin(bodyMeasures(), view.main);
      const tag = prov.querySelector('[data-ce-sg-fit]');
      tag.dataset.fit = view.main;
      tag.innerHTML = `<span class="ce-sg-fit__icon" aria-hidden="true">↔</span>${FIT[view.main]} no ${esc(k0.nome)}`;
      viewfit.hidden = true;
    } else {
      viewfit.hidden = false;
      viewfit.dataset.fit = view.main;
      viewfit.textContent = `${sizeLabel} ${view.size}: ${FIT[view.main].toLowerCase()}`;
    }
    prov.querySelector('[data-ce-sg-viewing]').textContent = view.size;
    prov.querySelector('[data-ce-sg-choose]').textContent = `Escolher ${sizeLabel.toLowerCase()} ${view.size}`;
  }
})();
